module.exports = __webpack_public_path__ + "static/img/children6.4e4b1a17.jpg";